const KNOWLEDGE = 1;
const MANAGEMENT = 2;
const PARTICIPANT = 3;

export default {
  KNOWLEDGE,
  MANAGEMENT,
  PARTICIPANT
};
